export default class ContentExtractor {
  static get SELECTORS() {
    return {
      title: '[data-content-title]',
      subtitle: '[data-content-subtitle]',
      body: '[data-content-body]',
      cta: '[data-content-cta]',
    };
  }
  constructor(htmlEl) {
    this.blockElement = htmlEl;
    this.titleBlock = this.blockElement.querySelector(
      ContentExtractor.SELECTORS.title
    );
    this.subtitleBlock = this.blockElement.querySelector(
      ContentExtractor.SELECTORS.subtitle
    );
    this.bodyBlock = this.blockElement.querySelector(
      ContentExtractor.SELECTORS.body
    );
    this.ctaBlock = this.blockElement.querySelector(
      ContentExtractor.SELECTORS.cta
    );
  }
  get titleText() {
    if (!this.titleBlock) {
      console.warn('No title(data-content-title) found');
      return false;
    }
    return this.titleBlock.innerText;
  }
  get titleClone() {
    if (!this.titleBlock) {
      console.warn('No title(data-content-title) node found');
      return false;
    }
    return this.titleBlock.cloneNode(true);
  }
  get subtitleText() {
    if (!this.subtitleBlock) {
      console.warn('No subtitle(data-content-subtitle) found');
      return false;
    }
    return this.subtitleBlock.innerText;
  }
  get subtitleClone() {
    if (!this.subtitleBlock) {
      console.warn('No subtitle(data-content-subtitle) node found');
      return false;
    }
    return this.subtitleBlock.cloneNode(true);
  }
  get bodyClone() {
    if (!this.bodyBlock) {
      console.warn('No body(data-content-body) node found');
      return false;
    }
    return this.bodyBlock.cloneNode(true);
  }
  get ctaClone() {
    if (!this.ctaBlock) {
      console.warn('No cta(data-content-cta) node found');
      return false;
    }
    return this.ctaBlock.cloneNode(true);
  }
}
